<template>
  <gat-dialog
    v-model="dialogVisible"
    cancelButtonCaption="CLOSE"
    okButtonCaption="DOWNLOAD DOCUMENT"
    width="600"
    @okClick="download(doc.ID, doc.FILENAME)"
    @cancelClick="close()"
    :okButtonDisabled="OkDisabled">
    <v-stepper :value="docStatus" class="elevation-0">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="docStatus > 0">Added to queue</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="docStatus > 1">Generation started</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step v-if="docStatus <= 3" step="3" :complete="docStatus > 2">Document ready</v-stepper-step>
        <v-stepper-step
          v-if="docStatus == 4"
          step="3"
          :complete="docStatus > 2"
          complete-icon="mdi-close-circle-outline"
          color="red"
          ><span style="color: red">Generation failed</span></v-stepper-step
        >
      </v-stepper-header>
    </v-stepper>

    <span v-if="docStatus < 3">Your document should be ready in a few seconds.</span>
    <div v-else-if="docStatus == 3" class="ml-5 d-flex align-center">
      <span>Your document is ready:</span>
      <div class="ml-2 d-flex align-center">
        <span
          ><v-icon :color="getMdiFileIcon(doc.FILENAME).color">{{ getMdiFileIcon(doc.FILENAME).icon }}</v-icon></span
        >
        <span> {{ doc.FILENAME }} </span>
      </div>
    </div>
    <span v-else-if="docStatus == 4" class="ml-5">
      <span>Something went wrong with the document generation.</span>
    </span>
  </gat-dialog>
</template>

<script>
import { apiGet, apiGetFile } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';
import DocumentHelper from '@/common/DocumentHelper';

export default {
  name: 'DocumentStatus',
  props: ['guid', 'showForm'],
  components: {},
  setup() {
    const applicationStore = useApplicationStore();
    return {
      applicationStore,
    };
  },
  data() {
    return {
      dialogVisible: this.showForm,
      docStatus: 0,
      interval: null,
      doc: { FILENAME: 'Proforma with vouchers.pdf' },
    };
  },

  computed: {
    OkDisabled() {
      return this.docStatus !== 3;
    },
  },

  mounted() {
    this.dialogVisible = this.showForm;
  },

  created() {},

  watch: {
    showForm(newValue) {
      this.dialogVisible = newValue;
    },
    guid(newValue, oldValue) {
      if (oldValue) {
        this.docStatus = 0;
      }
      if (newValue) {
        this.checkStatus();
      }
    },
  },

  methods: {
    getMdiFileIcon(fileName) {
      return DocumentHelper.getMdiFileIcon(fileName);
    },
    checkStatus() {
      apiGet(`document/status/${this.guid}`).then((data) => {
        if (data && data.DQU_QUEUE_STATUS) {
          this.docStatus = data.DQU_QUEUE_STATUS;
        }
        if (this.applicationStore.debugMode) {
          console.log(this.docStatus);
        }
        if (this.docStatus < 3) {
          setTimeout(this.checkStatus, 2000);
        } else {
          if (this.docStatus == 3) {
            this.doc.FILENAME = data.FILENAME;
            this.doc.TITLE = data.TITLE;
            this.doc.ID = data.DQU_DOCUMENT_ID;
            this.$emit('documentCreated');
          }
          if (!this.dialogVisible) {
            this.$emit('documentReady');
          }
        }
      });
    },
    close() {
      this.$emit('close');
    },

    download(docId, fileName) {
      if (docId) {
        // && this.applicationStore.globalSettings.SGL_DOC_ENGINE_VER
        apiGetFile(`document/download/${docId}`, fileName).then(() => {
          this.close();
        });
      }
    },

    open() {},
  },
};
</script>

<style scoped></style>
